export const PORTAL_PATIENT_ROUTES = {
	home: "/portal-patient",
	branches: "/portal-patient/branches",
	unit: "/portal-patient/unit",
	unitDetail: (unitId: string) => `/portal-patient/unit-detail/${unitId}`,
	doctor: "/portal-patient/doctor",
	payment: "/portal-patient/payment",
	paymentModal: "/portal-patient/payment-modal",
	paymentModalContent: "/portal-patient/payment-modal-content",
	schedule: "/portal-patient/schedule",
	scheduleModal: "/portal-patient/schedule-modal",
	booking: "/portal-patient/booking",
	bookingConfirm: "/portal-patient/booking-confirm",
	profile: "/portal-patient/profile",
	sync: "/portal-patient/sync",
	preAssessmentMcu: "/portal-patient/pre-assessment-mcu",
	preAssessmentMcuForm: (regId: string) =>
		`/portal-patient/pre-assessment-mcu/${regId}/form`,
} as const;
